/**
 * Countries for filters: ISO 3166-1 alpha-2 codes, named in English by the browser. Records
 * store the English name as free text (RecruitCRM's spelling), so the name is the option value.
 */
const CODES =
  'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ ' +
  'BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM ' +
  'DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS ' +
  'GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN ' +
  'KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ ' +
  'MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM ' +
  'PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV ' +
  'SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI ' +
  'VN VU WF WS XK YE YT ZA ZM ZW';

/** The flag emoji: each letter as its regional indicator symbol. */
export function flagOf(code: string): string {
  return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1f1a5 + c.charCodeAt(0)));
}

let cached: Array<{ value: string; label: string }> | undefined;

/** `{ value: 'Colombia', label: '🇨🇴 Colombia' }` for every country, by name. */
export function countryOptions(): Array<{ value: string; label: string }> {
  if (cached) return cached;
  const names = new Intl.DisplayNames(['en'], { type: 'region' });
  cached = CODES.split(' ')
    .map((code) => {
      const name = names.of(code) ?? code;
      return { value: name, label: `${flagOf(code)} ${name}` };
    })
    .sort((a, b) => a.value.localeCompare(b.value));
  return cached;
}

/** The flag for a stored country name (any case), or '' for a name that is not a country. */
export function flagForCountry(name: unknown): string {
  if (typeof name !== 'string' || !name.trim()) return '';
  const wanted = name.trim().toLowerCase();
  const found = countryOptions().find((o) => o.value.toLowerCase() === wanted);
  return found ? found.label.slice(0, found.label.indexOf(' ')) : '';
}
